import React from 'react'
import { Topbar, Aside, Main, PageHeader } from 'components';

function Contact() {

    return (
        <main>
            <Topbar />

            <div className='pt-14 w-full flex overflow-hidden bg-light-bg dark:bg-dark-page'>
                <Aside />

                <Main>
                    <div className='max-w-7xl mx-auto px-4 py-8'>

                        <PageHeader title='Contact Us' size="text-2xl" />

                        <section className='mb-8'>
                            <h2 className='text-xl font-bold mb-3'>Reach out today:</h2>
                            <p className='text-sm leading-relaxed text-gray-700 dark:text-gray-300'>
                                Call us at{' '}
                                <a href='tel:+233595740032' className='text-blue-500 font-semibold hover:underline'>0595 740 032</a>,{' '}
                                <a href='tel:+233595741614' className='text-blue-500 font-semibold hover:underline'>0595 741 614</a>{' '}
                                or{' '}
                                <a href='tel:+233595741673' className='text-blue-500 font-semibold hover:underline'>0595 741 673</a>{' '}
                                or send a message or email us at{' '}
                                <a href='mailto:applications@cedispay.com.gh' className='text-blue-500 hover:underline'>applications@cedispay.com.gh</a>.{' '}
                                We're here for your account questions, salary loans, business loans and more!
                            </p>
                        </section>

                        <section className='mb-8'>
                            <h2 className='text-xl font-bold mb-3'>Call centre:</h2>
                            <p className='text-sm leading-relaxed text-gray-700 dark:text-gray-300'>
                                Monday - Friday: 8:00 AM - 8:00 PM / Saturday - Sunday: 9:00 AM - 6:00 PM.
                            </p>
                        </section>

                    </div>
                </Main>
            </div>
        </main>
  )
}

export default Contact